// project imports
import gestopAPI from 'utils/gestopAPI';
import { errorProcessor } from 'utils/processors';

export const ApiLicensesGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('admin/licenses/list', { filters, orderBy, groupBy, page, limit }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.list);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiLicensesCountCollection = async ({ filters = [], successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .post('admin/licenses/count', { filters }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiLicensesPostCollection = async ({ data = {}, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .post('admin/licenses', data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } // Specific content type for file requests
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiLicensesDeleteCollection = async ({ ids = [], successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .post('admin/licenses/delete', ids, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiLicensesDeleteItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .get(`admin/licenses/delete/${id}`, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiLicensesGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .get(`admin/licenses/${id}`, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};
